import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as auth from "../../store/ducks/auth.duck";
import { redeemTransfer, me } from "../../crud/auth.crud";
import { toAbsoluteUrl } from "../../../_metronic";

const safeLocalStorageSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn(`Falha ao salvar ${key} no localStorage:`, e);
    return false;
  }
};

const clearPreviousSession = () => {
  const keysToRemove = [
    "authToken",
    "impersonation_active",
    "impersonation_session_id",
    "impersonation_expires_at",
    "impersonation_requester",
    "impersonation_approver",
  ];

  keysToRemove.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.warn(`Falha ao remover ${key} do localStorage:`, e);
    }
  });
};

const IMPERSONATION_DATA = {
  impersonation_active: () => "true",
  impersonation_session_id: (data) => data.session_id,
  impersonation_expires_at: (data) => data.expires_at,
  impersonation_requester: (data) => JSON.stringify(data.requester),
  impersonation_approver: (data) => JSON.stringify(data.approver),
};

const storeImpersonationData = (impersonation) => {
  if (!impersonation) return;

  Object.entries(IMPERSONATION_DATA).forEach(([key, getValue]) => {
    safeLocalStorageSet(key, getValue(impersonation));
  });
};

function SsoAuth(props) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const history = useHistory();

  useEffect(() => {
    authenticateWithToken();
  }, []);

  const authenticateWithToken = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const transferToken = urlParams.get("token");

    if (!transferToken) {
      setError("Token de autenticação não fornecido");
      setLoading(false);
      return;
    }

    try {
      clearPreviousSession();

      await redeemTransfer(transferToken);

      const meResponse = await me();
      const meData = meResponse.data;

      if (meData.identity?.ctx !== 'painel') {
        throw new Error('Contexto inválido para este painel.');
      }

      storeImpersonationData(meData?.impersonation);

      props.login({ user: meData, authToken: undefined });

      history.push("/");
    } catch (err) {
      console.error("Erro ao autenticar com token:", err);
      setError(
        err.response?.data?.errors?.[0] ||
          err.response?.data?.message ||
          err.message ||
          "Erro ao autenticar. Token inválido ou expirado."
      );
      setLoading(false);
    }
  };

  const renderMessage = (
    title,
    message = null,
    titleColor = null,
    showSpinner = false
  ) => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <div className="card-login">
        <div
          className="card-login-container-logo"
          style={{ textAlign: "center" }}
        >
          <img
            alt="Logo"
            src={toAbsoluteUrl("/images/new_logo.png")}
            style={{ height: "40px", marginBottom: "48px" }}
          />
        </div>
        <h3
          className="card-login-title"
          style={
            titleColor
              ? { color: titleColor, textAlign: "center" }
              : { textAlign: "center" }
          }
        >
          {title}
        </h3>
        {message && (
          <p style={{ textAlign: "center", marginTop: "24px", color: "#666" }}>
            {message}
          </p>
        )}
        {showSpinner && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "24px",
            }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Carregando...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  if (loading) {
    return renderMessage("Autenticando...", null, null, true);
  }

  if (error) {
    return renderMessage("Erro na Autenticação", error, "#f44336", false);
  }

  return null;
}

export default connect(null, auth.actions)(SsoAuth);
